<div id="content" class="allcp-form" ng-controller="StockMovementController" ng-init="all()">
    <div ng-include="'modules/company/menus/stock_menu.html'"></div>
    <div class="panel-body">
        <div class="table-responsive" ng-if="data.stockMovements.data.length > 0">
            <small class="pull-right pr10 total-record">Toplam Kayıt : {{ data.stockMovements.total }}</small>
            <br>
            <dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)" template-url="dirPagination.tpl.html" class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
            <table class="table table-hover tc-checkbox-1 fs13">
                <thead>
                    <tr class="bg-light">
                        <th class="text-center w100">#</th>
                        <th>
                            Stok
                            <a ng-click="sort('stock_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('stock_id','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Stok Seri No
                        </th>
                        <th>
                            Hareket
                            <a ng-click="sort('type','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('type','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Miktar
                            <a ng-click="sort('piece','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('piece','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Tür
                            <a ng-click="sort('part_type','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('part_type','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Açıklama
                            <a ng-click="sort('description','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('description','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            Bağlı Old.Kargo
                            <a ng-click="sort('order_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('order_id','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                        <th>
                            İşlem Yapan Personel
                            <a ng-click="sort('worker_id','desc')" ng-if="filterData.sort == 'asc' || !filterData.field">
                                <i class="fa fa-sort-alpha-desc"></i>
                            </a>
                            <a ng-click="sort('worker_id','asc')" ng-if="filterData.sort == 'desc'">
                                <i class="fa fa-sort-alpha-asc"></i>
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr dir-paginate="item in data.stockMovements.data | itemsPerPage: 30" total-items="data.stockMovements.total" current-page="data.stockMovements.current_page">
                        <td class="text-center">
                            <label class="option block mn">
                                <input type="checkbox" name="deleted[]" ng-checked="deleted.indexOf(item.id) > -1" ng-click="toggleSelection(item.id)">
                                <span class="checkbox mn"></span>
                            </label>
                        </td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.stock.name }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.stock.serial_number }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">
                            <span ng-if="item.type == 0" class="label label-primary"> Hareket Yok</span>
                            <span ng-if="item.type == -1" class="label label-danger"> Çıkış</span>
                            <span ng-if="item.type == 1" class="label label-success"> Giriş</span>
                        </td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.piece +' '+ item.stock.unit }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.part_type }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.description }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.order_id }}</td>
                        <td class="clickable-row" ng-click="getStockMovement(item.id)">{{ item.worker ? item.worker.full_name : '-' }}</td>
                    </tr>
                </tbody>
            </table>
            <dir-pagination-controls boundary-links="true" on-page-change="getPage(newPageNumber)" template-url="dirPagination.tpl.html" class="pagination-lg pagination pull-right pr10">
            </dir-pagination-controls>
        </div>
        <div class="table-responsive" ng-if="data.stockMovements.data.length == 0">
            <div class="alert alert-default pastel">
                <i class="fa fa-info pr10"></i>
                <strong>
                    Kayıtlı stok hareketi bulunamadı! <a href="stok/hareket/yeni">Buraya</a> tıklayarak yeni stok oluşturubilirsiniz.
                </strong>
            </div>
        </div>
    </div>
    <div ng-include="'modules/company/settings/partials/delete.html'"></div>
</div>